import React from 'react';
import { Table } from '../../components/Table';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';

export interface Column {
  key: string;
  title: string;
  width: string;
}

export interface StaticReferencePageProps<T extends { id: string }> {
  title: string;
  items: T[];
  columns: readonly Column[] | Column[];
}

/**
 * Компонент для статичных справочников (только просмотр)
 * Отличается от ReferencePage отсутствием возможности редактирования
 */
export function StaticReferencePage<T extends { id: string }>({
  title,
  items,
  columns,
}: StaticReferencePageProps<T>) {
  const { t } = useLanguage();
  const { theme } = useTheme();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <div className="section-header">
        <h2>{title}</h2>
        <div style={{
          padding: '8px 16px',
          backgroundColor: theme.isDark ? 'rgba(77, 127, 255, 0.1)' : 'rgba(0, 52, 151, 0.1)',
          color: theme.isDark ? '#4d7fff' : '#003497',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          📖 {t('common.readOnly')}
        </div>
      </div>

      <Table
        theme={theme}
        title={title}
        data={items}
        columns={columns as any}
        readOnly={true}
      />
    </div>
  );
}
